module.exports = __webpack_public_path__ + "img/icon-subcribed-questions.1dac85c4.png";